var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FeedbackList',{attrs:{"reportId":_vm.$route.params.id,"contractorId":_vm.report.contractor.uuid,"type":"report"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }